import { ClassInstructorDTO } from "@/api/dto/classes/ClassInstructorDTO";
import { useUtility } from "@/composables/useUtility";

export interface IClassInstructor {
  id: number;
  firstName: string;
  lastName: string;
  active: boolean;
}

export class ClassInstructor implements IClassInstructor {
  id;
  firstName;
  lastName;
  active;

  constructor(config: IClassInstructor) {
    this.id = config.id;
    this.firstName = config.firstName;
    this.lastName = config.lastName;
    this.active = config.active;
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim();
  }
}

export const classInstructorMapper = (dto: ClassInstructorDTO) => {
  const { mapPseudoBool } = useUtility();

  return new ClassInstructor({
    id: dto.instructorId,
    firstName: dto.nameFirst,
    lastName: dto.nameLast,
    active: mapPseudoBool(dto.active) || false,
  });
};
